var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.336,
    height: 53.336,
    viewBox: "0 0 53.336 53.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 53.336,
    height: 53.336,
    rx: 15,
    transform: "translate(0)",
    fill: "#e0057f",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 42.114,
    height: 25.88,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_332",
    "data-name": "Groupe 332",
    transform: "translate(-8.312 -2831.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_234",
    "data-name": "Groupe 234",
    transform: "translate(8.312 2831.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_7",
    "data-name": "Groupe de masques 7",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 53.336,
    height: 53.336,
    transform: "translate(0 0)",
    fill: "#e0057f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_227",
    "data-name": "Groupe 227",
    transform: "translate(5.611 20.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_226",
    "data-name": "Groupe 226",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_301",
    "data-name": "Trac\\xE9 301",
    d: "M41.41,21.761a.7.7,0,0,1-.7-.7,19.648,19.648,0,1,0-39.3,0,.7.7,0,0,1-1.409,0A21.057,21.057,0,0,1,35.947,6.167a20.919,20.919,0,0,1,6.167,14.89.7.7,0,0,1-.7.7",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_302",
    "data-name": "Trac\\xE9 302",
    d: "M434.228,123.476a.7.7,0,0,1-.7-.7,16.809,16.809,0,0,0-4.373-11.324.7.7,0,1,1,1.043-.948,18.215,18.215,0,0,1,4.739,12.272.7.7,0,0,1-.7.7",
    transform: "translate(-395.378 -101.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_303",
    "data-name": "Trac\\xE9 303",
    d: "M39.513,55.729a.7.7,0,0,1-.7-.7A18.259,18.259,0,0,1,68.62,40.886a.7.7,0,0,1-.892,1.091,16.849,16.849,0,0,0-27.51,13.048.7.7,0,0,1-.7.7",
    transform: "translate(-35.769 -33.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_304",
    "data-name": "Trac\\xE9 304",
    d: "M266.788,58.973a.7.7,0,0,1-.573-1.114l9.512-13.342-13.17,9.289a.7.7,0,0,1-.812-1.152L278.3,40.979a.7.7,0,0,1,.98.985L267.363,58.678a.7.7,0,0,1-.574.3",
    transform: "translate(-240.974 -37.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_305",
    "data-name": "Trac\\xE9 305",
    d: "M207.516,205.67a5.3,5.3,0,1,1,5.3-5.3,5.309,5.309,0,0,1-5.3,5.3m0-9.2a3.894,3.894,0,1,0,3.894,3.894,3.9,3.9,0,0,0-3.894-3.894",
    transform: "translate(-186.379 -179.79)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "TH",
    d: "M2.342,8.132a.236.236,0,0,1-.044,0A.205.205,0,0,1,2.22,8.1a.231.231,0,0,1-.034-.028Q2.122,8,2.122,7.913V2.854H.43q-.091,0-.156-.064T.21,2.634V1.957q0-.1.064-.165T.43,1.728H5.1q.1,0,.165.064t.064.165v.677q0,.091-.064.156T5.1,2.854H3.412V7.913q0,.091-.064.156a.216.216,0,0,1-.034.028.208.208,0,0,1-.039.02.228.228,0,0,1-.043.012.278.278,0,0,1-.048,0Zm4.126,0a.254.254,0,0,1-.044,0,.22.22,0,0,1-.041-.011A.212.212,0,0,1,6.346,8.1a.228.228,0,0,1-.034-.026q-.064-.059-.064-.16V1.957q0-.1.064-.165t.156-.064H7.3q.1,0,.16.064t.059.165v2.36h2.7V1.957q0-.1.064-.165t.156-.064h.823q.1,0,.165.064t.064.165V7.913q0,.091-.064.156a.216.216,0,0,1-.034.028.208.208,0,0,1-.039.02.228.228,0,0,1-.043.012.278.278,0,0,1-.048,0h-.823a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V5.461H7.52V7.913q0,.091-.059.156a.2.2,0,0,1-.032.028.191.191,0,0,1-.037.02.216.216,0,0,1-.043.012.273.273,0,0,1-.048,0Z",
    transform: "translate(20.583 5.09)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTh);
export default __webpack_public_path__ + "static/media/TH.3dd9a64eb410439ad59f110256e5e842.svg";
export { ForwardRef as ReactComponent };